.add {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.blurb {
	margin: 0;
}

.passkeys {
	display: flex;
	flex-direction: column;
	margin-top: var(--size-4);

	&:empty {
		display: none;
	}
}

.passkey {
	display: flex;
	gap: var(--size-2);
	justify-content: space-between;
	align-items: center;
	padding: var(--size-2) 0;

	&:last-child {
		padding-bottom: 0;
	}
}

.passkeyInfo {
	display: flex;
	align-items: baseline;
	gap: var(--size-4);
}

.passkeyName {
	font-weight: bold;
}

.passkeyUsed {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.actions {
	display: flex;
	gap: var(--size-3);
	justify-content: flex-end;
}

.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);

	&:empty {
		display: none;
	}
}

.form {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	min-width: 30rem;
}
